import React, { useState, useEffect, useRef } from 'react';
import { Chart } from '@antv/g2';
import './index.less';

export interface HeadProps {
  data: any[],
  noPercent?: boolean,
  color?: string[],
  onDataUrl?: (chart: any) => void,
}

const PieChart = (props: HeadProps) => {
  const { data, color, noPercent, onDataUrl } = props;
  const divRef: React.RefObject<HTMLDivElement> = useRef(null)
  const [pieChart, setChart] = useState<any>(null);

  useEffect(() => {
    if (!divRef.current) {
      return
    }
    if (pieChart) {
      pieChart.destroy()
    }

    const chart = new Chart({
      container: divRef.current,
      autoFit: true,
      height: 296,
    });

    chart.coordinate('theta', {
      radius: 0.75,
    });

    chart.data(data);
    chart.tooltip(false);
    chart.legend(false)
    chart
      .interval()
      .position('value')
      .color('label', color)
      .label('value', {
        content: (data) => {
          return `${data.label}: ${data.value}${noPercent ? '' : '%'}`;
        },
      })
      .adjust('stack');

    chart.render();
    setChart(chart)
  }, [data, color, noPercent, divRef.current]);

  useEffect(() => {
    if (pieChart && typeof onDataUrl === 'function') {
      setTimeout(() => {
        onDataUrl(pieChart)
      }, 1000)
    }
  }, [onDataUrl, pieChart])

  return (
    <div ref={divRef} style={{ width: 492, height: 282 }}></div>
  );
};

export default React.memo(PieChart);
